import React, { useEffect, useState } from "react";
import "../create/Notification_Create.css";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { AllHosts } from "../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetHost } from "../../../../features/admin/host/slice";
import Success_Modal from "../../../common_components/common-modal/success_modal/Success_Modal";
import Reject_Modal from "../../../common_components/common-modal/reject_modal/Reject_Modal";

import {
  GetAllCustomer,
  GetCustomer,
  UpdateCustomer,
} from "../../../../features/admin/customer/Slice";
import { Form } from "react-bootstrap";
import { faEye, faEyeSlash, faL } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  GetAllAppSetup,
  GetAppSetup,
  UpdateAppSetup,
} from "../../../../features/admin/app_setup/Slice";

const Student_Detail_Create = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showSuccess, setShowSuccess] = useState(false);
  const [showReject, setShowReject] = useState(false);

  const { id } = useParams();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    watch,
  } = useForm({});

  const [showPassword, setShowPassword] = useState({
    password: false,
    confirm: false,
  });

  const togglePasswordVisibility = (type) => {
    setShowPassword((prev) => ({ ...prev, [type]: !prev[type] }));
  };
  const newPassword = watch("password", "");

  const allHostData = useSelector((state) => state.common.all_hosts);

  useEffect(() => {
    dispatch(GetAllAppSetup());
  }, [dispatch]);

  const GetData = async (hostId) => {
    try {
      const res = await dispatch(GetAppSetup(hostId)).unwrap();

      const hostData = res?.data;

      if (!hostData) {
        return;
      }

      reset({
        email: hostData?.email || "",
        contact_no: hostData?.contact_no || "",
        AppID: hostData?.AppID || "",
        AppSign: hostData?.AppSign || "",
        CallbackSecret: hostData?.CallbackSecret || "",
        ServerSecret: hostData?.ServerSecret || "",
        ServerSecret: hostData?.ServerSecret || "",
      });
    } catch (error) {
      console.error("Get Host Error:", error);
    }
  };

  useEffect(() => {
    if (id) {
      GetData(Number(id));
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        contact_no: data.contact_no,
        AppID: data.AppID,
        email: data.email,
        AppSign: data.AppSign,
        ServerSecret: data.ServerSecret,
        CallbackSecret: data.CallbackSecret,
      };

      const res = await dispatch(
        UpdateAppSetup({
          id,
          data: payload,
        }),
      ).unwrap();

      if (res?.success) {
        dispatch(GetAllAppSetup());

        setShowSuccess(true);

        setTimeout(() => {
          setShowSuccess(false);
          navigate(-1);
        }, 3000);
      } else {
        setShowReject(true);

        setTimeout(() => {
          setShowReject(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Update Customer Error:", error);

      setShowReject(true);

      setTimeout(() => {
        setShowReject(false);
      }, 3000);
    }
  };
  return (
    <section className="Student_Detail_Create common_section">
      <div className="section_filter_div">
        <p className="filter_title">Edit Notification</p>
      </div>

      <div className="host-user-card">
        {" "}
        <div className="form-ro">
          <div className="form-control-wrapper1">
            <button
              type="submit"
              className="submit-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          <br />
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="form-wrapper-div">
          <div className="form-row">
            <label className="form-label">
              Email <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Email"
                className="form-input"
                {...register("email", {
                  required: "Email is required",
                })}
              />

              {errors.email && (
                <span className="text-danger">{errors.email.message}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <label className="form-label">
              Contact <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Contact No"
                className="form-input"
                {...register("contact_no", {
                  required: "Contact No is required",
                })}
              />

              {errors.contact_no && (
                <span className="text-danger">{errors.message.contact_no}</span>
              )}
            </div>
          </div>{" "}
          <div className="form-row">
            <label className="form-label">
              App ID <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="AppID"
                className="form-input"
                {...register("AppID", {
                  required: "AppID is required",
                })}
              />

              {errors.AppID && (
                <span className="text-danger">{errors.message.AppID}</span>
              )}
            </div>
          </div>{" "}
          <div className="form-row">
            <label className="form-label">
              App Sign <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="App Sign"
                className="form-input"
                {...register("AppSign", {
                  required: "App Sign is required",
                })}
              />

              {errors.AppSign && (
                <span className="text-danger">{errors.message.AppSign}</span>
              )}
            </div>
          </div>{" "}
          <div className="form-row">
            <label className="form-label">
              Server Secret <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Server Secret"
                className="form-input"
                {...register("ServerSecret", {
                  required: "Server Secret is required",
                })}
              />

              {errors.ServerSecret && (
                <span className="text-danger">
                  {errors.message.ServerSecret}
                </span>
              )}
            </div>
          </div>{" "}
          <div className="form-row">
            <label className="form-label">
              Callback Secret <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Callback Secret"
                className="form-input"
                {...register("CallbackSecret", {
                  required: "Callback Secret is required",
                })}
              />

              {errors.CallbackSecret && (
                <span className="text-danger">
                  {errors.message.CallbackSecret}
                </span>
              )}
            </div>
          </div>{" "}
          {/* Confirm Password */}
          <div className="form-row">
            <div className="form-label"></div>

            <div className="form-control-wrapper">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
      <Success_Modal
        show={showSuccess}
        onHide={() => {
          setShowSuccess(false);
          navigate(-1);
        }}
      />

      <Reject_Modal
        show={showReject}
        onHide={() => {
          setShowReject(false);
          navigate(-1);
        }}
      />
    </section>
  );
};

export default Student_Detail_Create;
